import {
	createAPIModule,
	createSelectors,
} from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';
import { isBasketAdmin as getIsBasketAdmin } from 'modules/auth';

const getStateSlice = (state) => state.api.account.user.stateData.listForKey;

const getIsBlacklisted = createSelector(
	getIsBasketAdmin,
	(isBasketAdmin) => isBasketAdmin,
);

const moduleKeys = {
	NAVTRACKING: 'navTracking',
	FAVORITES: 'favorites',
};

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'ACCOUNT_USER_STATEDATA_LISTFORKEY',
	url: '/account/user/statedata/listForKey.json',
	getIsBlacklisted,
});

const navTrackingSelectors = createSelectors(
	getStateSlice,
	false,
	moduleKeys.NAVTRACKING,
);

const favoritesSelectors = createSelectors(
	getStateSlice,
	false,
	moduleKeys.FAVORITES,
);

const selectors = {
	navTrackingSelectors,
	favoritesSelectors,
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors, moduleKeys };
